import { useQuery } from 'react-query'
import { responsibleUser } from 'services/api'

export const useResponsibleUser = () => {
  return useQuery(['responsible-user'], () => responsibleUser(), {
    onError: () => console.log('error fetching responsible user'),
    retry: false,
  })
}
